import React from 'react'
import { useNavigate } from 'react-router-dom'
import type { Track } from 'types/track'
import { useMenu } from 'components/ds'

type Props = {
  manageTrackFormats: boolean
  disabled: boolean
  closeMenu: () => void
  track: Track
}

const ManageFilesAndFormats = ({
  manageTrackFormats,
  disabled,
  track,
}: Props): React.ReactNode => {
  const Menu = useMenu()
  const navigate = useNavigate()
  if (!manageTrackFormats || !track?.permissions?.manage) return null
  return (
    <Menu.Item
      disabled={disabled}
      onSelect={() => navigate(`/explorer/tracks/${track.id}/formats`)}
    >
      Files and format
    </Menu.Item>
  )
}

export default ManageFilesAndFormats
